// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduledMaintenanceTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceTypeApiClient extends BaseCRUDApiClient<ScheduledMaintenanceTypeDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
